"use client";
import { createSafeContext } from "../../core/utils/create-safe-context/create-safe-context.mjs";
//#region packages/@mantine/core/src/components/Modal/Modal.context.ts
const [ModalProvider, useModalContext] = createSafeContext("Modal component was not found in tree");
//#endregion
export { ModalProvider, useModalContext };

//# sourceMappingURL=Modal.context.mjs.map